import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import NotificationService from '../../../core/services/NotificationService';
import FileRepositoryTreeService from './FileRepositoryTreeService'
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';

class FileRepositoryFileService {
  form = new FormService();
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      selectedAttachmentId: null,
    });
    this.form.validations = {
      title: [isRequired],
      attachment: [isRequired],
    };
  }

  init = action(() => {
    this.form.reset();
    this.fetch.fetching = false;
    this.isOpen = false;
    this.selectedAttachmentId = null;
  });

  handleRemove = action(({ item }) => {
    ConfirmationDialogService.show(
      'Delete File',
      `You are sure to delete the file "${item.title}"?`,
      () => {
        this.fetch
          .fetch({
            url: `/attachment-repositories/${item.parent}/detach/${item.id}`,
            apiVersion: 'v3',
            method: 'delete',
          })
          .then(() => {
            NotificationService.addNotification(
              `File "${item.title}" deleted successfully.`,
              'success'
            );
            FileRepositoryTreeService.load();
          });
      }
    );
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.selectedAttachmentId = null;
    this.form.reset();
  });

  handleToggleModal = (selectedAttachmentId) => {
    this.form.reset();
    this.isOpen = !this.isOpen;
    this.isEditing = false;
    this.selectedAttachmentId = selectedAttachmentId
  };

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const formData = new FormData();
    formData.append('attachment', this.form.getValue('attachment'));
    formData.append('title', this.form.getValue('title'))
    formData.append('description', this.form.getValue('description'))

    this.submit = new FetchService();
    this.fetch.fetch({
      url: `/attachment-repositories/${this.selectedAttachmentId}/attach-file`,
      method: 'post',
      apiVersion: 'v3',
      body: formData,
    }).then(async () => {
      if (this.fetch.data) {
        FileRepositoryTreeService.load();
        NotificationService.addNotification(
          'File loaded successfully.',
          'success',
        );
        this.handleToggleModal();
      }
      
      if (this.fetch.error) {
        NotificationService.addNotification(
          'Error to load the file.',
          'error',
        );
      }
    });
  });
}

const fileRepositoryFileService = new FileRepositoryFileService();

export default fileRepositoryFileService;
